
  // variable declaration
  const btnFilterMobile = document.querySelector('.mobile-facets__open-wrapper .mobile-facets__open');
  const btnSortingMobile = document.querySelector('.mobile-facets__open-wrapper .mobile-sort-button');
  const btnCloseMobileDrawer = document.querySelector('.mobile-facets__open-wrapper .mobile-facets__close');
  const btnApplySortingFilter = document.querySelector('.mobile-facets__footer .btn-apply-filter-sort');
  const btnApplyFilter = document.querySelector('.mobile-facets__footer .btn-apply-filter');
  const btnRelevence = document.querySelector('.btn-relevence');
  const mobileMenuDrawer = document.querySelector('.main-facets-container .mobile-facets__wrapper');

  /**
   * Function is used to toggle offer list.
   * @param {object} event
   */
  const expandList = (event) => {
    try {      
        let btnExpandList = event.currentTarget;
        let parentContainerClass = btnExpandList.getAttribute('data-containerId');

        const parentContainerItem = document.querySelector(`.${parentContainerClass}`);
        const expandLinkText = document.querySelector(`.${parentContainerClass} .btn-expand-text`);

        parentContainerItem.classList.toggle('expand-list');
        expandLinkText.textContent = expandLinkText.textContent === 'View More' ? 'View Less' : 'View More';
    } catch (error) {
        console.error(error);     
    }
  };

  /**
   * Function is used for Collection Pagination.
   */
  window.onClickCollectionPagination = async (link, event) => {
    event.preventDefault();
    event.currentTarget.classList.add('hidden');

    /*
    link.style.width = `${link.offsetWidth}px`;
    link.style.height = `${link.offsetHeight}px`;

      link.innerHTML = `
        <div class="spinner-border spinner-border-sm mx-auto" role="status" style="width: 1.2rem; height: 1.2rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `;  
   */

    try {
        
        const response = await fetch(link.getAttribute('href'));
        const data = await response.text();

        const parser = new DOMParser();
        const newDocument = parser.parseFromString(data, 'text/html');

        document
        .querySelector('.product-container .product-grid-container')
        .insertAdjacentHTML(
            'beforeend',
            newDocument.querySelector('.product-container .product-grid-container').innerHTML
        );

        // document.querySelector('#collection-pagination').replaceWith(newDocument.querySelector('#collection-pagination'));

        const customEvent = new CustomEvent('ks.collection.paginated');
        link.dispatchEvent(customEvent);
    } catch (error) {
        console.error(error);    
    }
  };

//this fuction used only for top deal collection
 window.onClickCollectionPagination1 = async (link, event) => {
    event.preventDefault();
  // event.currentTarget.classList.add('hidden');

    /*
    link.style.width = `${link.offsetWidth}px`;
    link.style.height = `${link.offsetHeight}px`;

      link.innerHTML = `
        <div class="spinner-border spinner-border-sm mx-auto" role="status" style="width: 1.2rem; height: 1.2rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `;  
   */

    try {
        
        const response = await fetch(link.getAttribute('href'));
        const data = await response.text();
        const parser = new DOMParser();
        const newDocument = parser.parseFromString(data, 'text/html');
        document
        .querySelector('.product-container #product-grid')
        .insertAdjacentHTML(
            'beforeend',
            newDocument.querySelector('.product-container #product-grid').innerHTML
        );       
        // document.querySelector('#collection-pagination').replaceWith(newDocument.querySelector('#collection-pagination'));
        const customEvent = new CustomEvent('ks.collection.paginated');
        link.dispatchEvent(customEvent);

     if(newDocument.querySelector(".btn-view-more.btnviewmortopdeals")){
           document.querySelector(".btn-view-more.btnviewmortopdeals").classList.remove('hidden');
           const getviewmorElem_from_fetch = newDocument.querySelector(".btn-view-more.btnviewmortopdeals").getAttribute("href");
           const getviewmorElem_from_DOM = document.querySelector(".btn-view-more.btnviewmortopdeals").getAttribute("href");       
           if(getviewmorElem_from_fetch != getviewmorElem_from_DOM)document.querySelector(".btn-view-more.btnviewmortopdeals").setAttribute("href",getviewmorElem_from_fetch);
     }else{
       document.querySelector(".btn-view-more.btnviewmortopdeals").classList.add('hidden');
     }
      
    } catch (error) {
        console.error(error);    
    }
   };
  /**
   * Function is used show color variant of product.
   * @param {object} event
   */
  const showColorVariantProduct = (event) => {
    try {
        
        let colorVariant = event.currentTarget;
        let productId = colorVariant.getAttribute('data-id');
        let index = colorVariant.getAttribute('data-index');
        let colorName = colorVariant.getAttribute('data-colorName');

        const productContainer = document.querySelector(`.product-container${index}-${productId}`);
        const mainContainerProducts = document.querySelectorAll(`.product-container-${productId} .plp-product`);

        const colorVariantContainer = document.querySelector(`.color-variants-${productId}`);
        const allColorVariants = productContainer.querySelectorAll(`.color-variants-${productId} .product-color-variant`);
        const selectedColorVariant = productContainer.querySelector(
        `.color-variants-${productId} .color-variant${index}-${productId}`
        );

        const colorContainer = productContainer.querySelector(`.color-container-${productId}`);
        const colorTitle = colorContainer.querySelector('.color-title .color-name');

        //products show/hide
        mainContainerProducts.forEach((item) => {
        item.style.display = 'none';
        });
        productContainer.style.display = 'block';

        //enable color variant
        allColorVariants.forEach((item) => {
        item.style.border = '1px solid #707070';
        });
        selectedColorVariant.style.border = '1px solid #F39201';

        colorTitle.textContent = colorName;
    } catch (error) {
        console.error(error);
    }
  };

 /**
  * Function is used to show filters options in menu drawer.
  */
  const showMobileFilters = () => {
    try {       
        const filtersContainer = document.querySelector('.main-facets-container .mobile-facets .mobile-facets__inner');
        filtersContainer.classList.add('enable-filters');
        mobileMenuDrawer.style.zIndex = 10;
        const allHeadingText = document.querySelectorAll('.mobile-facets__header .mobile-facets__heading');
        allHeadingText.forEach((item) => {
        item.textContent = 'Filters';
        });
    } catch (error) {
        console.error(error);   
    }
  };

 /**
  * Function is used to show sorting options in menu drawer.
  */
  const showMobileSorting = () => {
    try {      
        const sortingContainer = document.querySelector('.main-facets-container .mobile-facets .mobile-facets__inner');
        sortingContainer.classList.add('enable-sorting');
        mobileMenuDrawer.style.zIndex = 10;

        const allHeadingText = document.querySelectorAll(
        '.main-facets-container .mobile-facets__header .mobile-facets__heading'
        );
        allHeadingText.forEach((item) => {
        item.textContent = 'Sort';
        });
    } catch (error) {
        console.error(error);
    }
  };

 /**
  * Function is used to close menu drawer.
  */
  const closeFilterAndSortDrawer = () => {
    try{
        const filterAndSortContainer = document.querySelector(
        '.main-facets-container .mobile-facets .mobile-facets__inner'
        );
        if (filterAndSortContainer.classList.contains('enable-filters')) {
        filterAndSortContainer.classList.remove('enable-filters');
        }
        if (filterAndSortContainer.classList.contains('enable-sorting')) {
        filterAndSortContainer.classList.remove('enable-sorting');
        }
        mobileMenuDrawer.style.zIndex = 2;
    } catch (error) {
        console.error(error);    
    }
  };

 /**
  * Function is used to close menu drawer if clicked outside the menu drawer container.
  */
  const closeAndUpdateDrawer = (event) => {
    if (event.target.classList.contains('mobile-facets__open-wrapper')) {
      closeFilterAndSortDrawer();
    }
  };

  /**
  * Function executes on DOM Content Loaded.
  * (a) add borders conditionally based on child elements.
  */
  window.addEventListener('DOMContentLoaded',()=>{
    const verticalFilterContainer = document.querySelector('.main-facets-container #FacetsWrapperDesktop');
    const filterElements = document.querySelectorAll('.main-facets-container #FacetsWrapperDesktop .facets__disclosure-vertical');

    if(filterElements.length > 0){
      verticalFilterContainer.style.border = 'border: 1px solid #707070';
    }else{   
      verticalFilterContainer.style.border = 'none';
    }
  })

  //Event Listeners
  btnFilterMobile?.addEventListener('click', showMobileFilters);

  btnCloseMobileDrawer?.addEventListener('click', closeFilterAndSortDrawer);
  btnApplySortingFilter?.addEventListener('click', closeFilterAndSortDrawer);
  btnApplyFilter?.addEventListener('click', closeFilterAndSortDrawer);

  btnSortingMobile?.addEventListener('click', showMobileSorting);
  btnRelevence?.addEventListener('click', function () {
    btnSortingMobile.click();
  });

  mobileMenuDrawer?.addEventListener('click', function (event) {
    closeAndUpdateDrawer(event);
  });